module.exports = __webpack_public_path__ + "img/logo-light.53e190bf.png";